import styled from 'styled-components';

export type IStyledBagelCodeProductProps = {
  textColor: string;
  suffix: string;
};

export const StyledBagelCodeProduct = styled.div<IStyledBagelCodeProductProps>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-right: 16px;

  &:last-child {
    margin-right: 0;
  }

  .image-container {
    display: flex;
    justify-content: center;
    overflow: hidden;
    align-items: center;
    height: 64px;
    width: 64px;

    .image {
      max-width: 120px;
      height: 100%;
      width: 100%;
      object-fit: contain;
    }
  }

  .quantity {
    text-align: ${({ suffix }) => (suffix ? 'center' : 'left')};
    font-size: 1.25rem;
    line-height: normal;
    font-family: inherit;
    color: ${({ textColor }) => textColor};
    text-shadow: 0 -1px 0.2px #000, 0 1px 0.2px #000, -1px 0 0.2px #000,
      1px 0 0.2px #000, 1px 1px 0.2px #000, -1px -1px 0.2px #000,
      -1px 1px 0.2px #000, 1px -1px 0.2px #000;
  }

  .stroked {
    margin-top: 0;
    font-size: 12px;
    font-weight: 600;
    color: #c8c8c8;
    position: relative;

    &::after {
      content: ' ';
      height: 2px;
      width: 100%;
      background: #d8232a;
      position: absolute;
      left: 0;
      top: 50%;
    }
  }
`;
